//
// Splide Config
// --------------------------------------------------
// Checks page for panels utilising splide and initialises their splide sliders with configurations set here

import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';
import { PageUtils } from "./helpers/page-utils";

function closeLightBox(lightbox) {
    lightbox.dataset.visible = 'false';
    PageUtils.bodyLockToggleOff();

    setTimeout(() => {
        lightbox.dataset.hidden = 'true';
    }, 300);
}

function openLightBox(lightbox) {
    lightbox.dataset.hidden = 'false';
    PageUtils.bodyLockToggleOn();

    const docBody = document.body;
    const siteHeader = document.getElementById('siteHeader');
    siteHeader.dataset.visible = 'false';
    docBody.dataset.navVisible = 'false';

    setTimeout(() => {
        lightbox.dataset.visible = 'true';
    }, 50);
}

function documentKeydownHandler(event, lightbox, splide) {
    if (!lightbox.classList.contains('hidden')) {
        if (event.key === 'Escape') {
            closeLightBox(lightbox);
        }
        else if (event.key === 'ArrowRight') {
            splide.go('+1');
        }
        else if (event.key === 'ArrowLeft') {
            splide.go('-1');
        }
    }
}

window.addEventListener('load', () => {
    const availableCarousels = document.querySelectorAll('.splide');
    const gallerySplidePanel = document.querySelectorAll('.gallery-panel');
    const testimonialPanel = document.querySelectorAll('.testimonial-panel-slider');
    const cardPanel = document.querySelectorAll('.card-panel-slider');

    if (availableCarousels.length) {

        // START CARD PANEL SLIDER
        for ( const panel of cardPanel ) {
            const totalSlides = parseInt(panel.querySelector('.card-panel-splide').dataset.totalSlides);
            const paginationColor = panel.querySelector('.card-panel-splide').dataset.paginationColor;
            const paginationBorderColor = panel.querySelector('.card-panel-splide').dataset.paginationBorderColor;
            const arrowColor = panel.querySelector('.card-panel-splide').dataset.arrowColor;
            const destroySlideDesktop = panel.querySelector('.card-panel-splide').dataset.destroySplideDesktop === 'true' ? true : totalSlides <= 3;

            const cardSplide = new Splide(panel.querySelector('.card-panel-splide'), {
                type: 'slide',
                speed: 750,
                direction: 'ltr',
                pauseOnHover: true,
                arrows: true,
                perPage: 3,
                perMove: 1,
                pagination: true,
                autoplay: false,
                gap: '2rem',
                padding: '2rem',
                interval: 10000,
                destroy: destroySlideDesktop,
                classes: {
                    pagination: 'splide__pagination flex justify-center items-center gap-2 w-max !mx-auto pb-2 sm:!mr-6 sm:!mr-8',
                    page: 'splide__pagination__page rounded-full overflow-hidden w-3 h-3 opacity-50 hover:scale-105 [&.is-active]:opacity-100 transition-all duration-150 ease-in-out border' + ' ' + paginationColor + ' ' + paginationBorderColor,
                    arrows: 'splide__arrows absolute w-full sm:w-max h-max px-4 sm:px-0 flex items-center justify-between flex bottom-0 left-0 sm:bottom-[unset] sm:left-[unset] sm:top-2 lg:top-0 sm:right-6 lg:right-8 gap-4',
                    arrow: 'splide__arrow relative z-5 bg-transparent p-0 w-10 h-12 fill-current disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 active:!duration-75 active:!scale-125 disabled:!scale-100' + ' ' + arrowColor,
                    prev: 'splide__arrow--prev rotate-180',
                    next: 'splide__arrow--next',
                },
                breakpoints: {
                    1279: {
                        perPage: 3,
                        gap: '2rem',
                        padding: '2rem',
                        destroy: totalSlides <= 3,
                    },
                    1023: {
                        perPage: 2,
                        padding: '1.5rem',
                        gap: '1.5rem',
                        destroy: totalSlides <= 2,
                    },
                    767: {
                        perPage: 1,
                        padding: '1.5rem',
                        gap: '1.5rem',
                        destroy: totalSlides === 1,
                    },
                    639: {
                        perPage: 1,
                        padding: '1.5rem',
                        gap: '1.5rem',
                        destroy: totalSlides === 1,
                    },
                },
            });

            cardSplide.mount();
        }
        // END CARD PANEL SLIDER

        // START GALLERY PANEL SLIDER
        for ( let panel of gallerySplidePanel ) {
            const galleryThumbnails = panel.querySelectorAll('.gallery-panel-image');
            const totalSlides = Number(panel.querySelector('.gallery-splide').dataset.totalSlides);
            const lightbox = panel.querySelector('[data-lightbox="gallery-panel"]');
            const requiredSplidesPresent = (panel.querySelector('.gallery-lightbox-splide') && panel.querySelector('.gallery-splide'));
            const destroySlideDesktop = panel.querySelector('.gallery-splide').dataset.destroySplideDesktop === 'true';

            if (requiredSplidesPresent) {
                const galleryLightboxSplide = new Splide(panel.querySelector('.gallery-lightbox-splide'), {
                    type: 'fade',
                    speed: 750,
                    arrows: true,
                    pagination: false,
                    arrowPath: 'M2.68456 22.7027L30.604 22.7027L17.9866 35.4054C16.9128 36.4865 16.9128 38.1081 17.9866 39.1892C19.0604 40.2703 20.6711 40.2703 21.745 39.1892L39.1946 21.8919C39.1946 21.6216 39.4631 21.3514 39.7315 21.0811C39.7315 20.8108 40 20.5405 40 20C40 19.7297 40 19.1892 39.7315 18.9189C39.4631 18.6487 39.1946 18.3784 39.1946 18.1081L21.745 0.810811C20.6711 -0.27027 19.0604 -0.27027 17.9866 0.810811C16.9128 1.89189 16.9128 3.51351 17.9866 4.59459L30.604 17.2973L2.68456 17.2973C1.07382 17.2973 1.41767e-07 18.3784 0 20C-1.41766e-07 21.6216 1.34228 22.7027 2.68456 22.7027Z',
                    classes: {
                        arrows: 'splide__arrows absolute w-full h-full flex items-center justify-between',
                        arrow: 'splide__arrow relative flex items-center justify-center z-3 rounded-l-lg w-14 h-16 p-2 bg-black/20 2.5xl:bg-transparent 2.5xl:p-0 2.5xl:w-10 2.5xl:h-12 fill-current text-white disabled:text-white/20 transition-all duration-300 hover:scale-110 disabled:!scale-100',
                        prev: 'splide__arrow--prev left-0 2.5xl:-left-16 rotate-180',
                        next: 'splide__arrow--next right-0 2.5xl:-right-16',
                    },
                });

                const gallerySplide = new Splide(panel.querySelector('.gallery-splide'), {
                    type: 'loop',
                    speed: 750,
                    direction: 'ltr',
                    pauseOnHover: true,
                    arrows: true,
                    perPage: 3,
                    perMove: 1,
                    pagination: true,
                    autoplay: false,
                    gap: '2rem',
                    padding: '2rem',
                    destroy: destroySlideDesktop,
                    arrowPath: 'M2.68456 22.7027L30.604 22.7027L17.9866 35.4054C16.9128 36.4865 16.9128 38.1081 17.9866 39.1892C19.0604 40.2703 20.6711 40.2703 21.745 39.1892L39.1946 21.8919C39.1946 21.6216 39.4631 21.3514 39.7315 21.0811C39.7315 20.8108 40 20.5405 40 20C40 19.7297 40 19.1892 39.7315 18.9189C39.4631 18.6487 39.1946 18.3784 39.1946 18.1081L21.745 0.810811C20.6711 -0.27027 19.0604 -0.27027 17.9866 0.810811C16.9128 1.89189 16.9128 3.51351 17.9866 4.59459L30.604 17.2973L2.68456 17.2973C1.07382 17.2973 1.41767e-07 18.3784 0 20C-1.41766e-07 21.6216 1.34228 22.7027 2.68456 22.7027Z',
                    classes: {
                        pagination: 'splide__pagination absolute bottom-0 left-0 w-full h-12 flex items-center justify-center px-24 gap-1',
                        arrows: 'splide__arrows absolute bottom-0 left-0 w-full h-12 flex items-center justify-between px-6 lg:px-8',
                        page: 'splide__pagination__page rounded-full overflow-hidden w-3 h-3 bg-black/25 hover:scale-105 [&.is-active]:bg-black/100 transition-all duration-150 ease-in-out',
                        arrow: 'splide__arrow relative z-5 rounded-full w-12 h-12 p-4 bg-black fill-current text-white disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 active:!duration-75 active:!scale-125 disabled:!scale-100 disabled:!opacity-20',
                        prev: 'splide__arrow--prev rotate-180',
                        next: 'splide__arrow--next',
                    },
                    breakpoints: {
                        1023: {
                            perPage: 3,
                            padding: '1.5rem',
                            gap: '1.5rem',
                            destroy: totalSlides <= 3,
                        },
                        767: {
                            perPage: 2,
                            padding: '1.5rem',
                            gap: '1.5rem',
                            destroy: totalSlides <= 2,
                        },
                        639: {
                            perPage: 1,
                            padding: '1.5rem',
                            gap: '1.5rem',
                            destroy: totalSlides === 1,
                        },
                    },
                });

                if (lightbox) {
                    const lightboxBackdrop = lightbox.querySelector('[data-lightbox-backdrop]');
                    const lightboxClose = lightbox.querySelector('[data-lightbox-close]');
                    const lightboxProgressBar = lightbox.querySelector('[data-carousel-progress]');

                    // Closes lightbox on backdrop/close button press
                    if (lightboxBackdrop) {
                        lightboxBackdrop.addEventListener('click', () => closeLightBox(lightbox));
                    }
                    if (lightboxClose) {
                        lightboxClose.addEventListener('click', () => closeLightBox(lightbox));
                    }

                    // Updates carousel progress bar width
                    if (lightboxProgressBar) {
                        galleryLightboxSplide.on('mounted move', function () {
                            let end = galleryLightboxSplide.Components.Controller.getEnd() + 1;
                            lightboxProgressBar.style.width = String(100 * (galleryLightboxSplide.index + 1) / end) + '%';
                        });
                    }

                    // Closes lightbox on key 'esc' press or navigates slider on keys 'arrowLeft' and 'arrowRight'
                    document.addEventListener('keydown', (e) => documentKeydownHandler(e, lightbox, galleryLightboxSplide));
                }

                // Opens lightbox and navigates carousel to the thumbnail that was pressed
                for ( let thumbnail of galleryThumbnails ) {
                    thumbnail.addEventListener('click', () => {
                        if (thumbnail.dataset.slide.length) {
                            galleryLightboxSplide.go(parseInt(thumbnail.dataset.slide));
                        }
                        openLightBox(lightbox);
                    });
                }

                galleryLightboxSplide.mount();
                gallerySplide.mount()
                gallerySplide.sync(galleryLightboxSplide);
            }
        }
        // END GALLERY PANEL SLIDER

        // START TESTIMONIAL PANEL SLIDER
        for ( const panel of testimonialPanel ) {
            const totalSlides = parseInt(panel.querySelector('.testimonial-panel-splide').dataset.totalSlides);
            const paginationColor = panel.querySelector('.testimonial-panel-splide').dataset.paginationColor;

            const cardSplide = new Splide(panel.querySelector('.testimonial-panel-splide'), {
                type: 'loop',
                speed: 750,
                direction: 'ltr',
                pauseOnHover: true,
                arrows: true,
                perPage: 3,
                perMove: 1,
                pagination: false,
                autoplay: true,
                gap: '2rem',
                padding: '2rem',
                interval: 7500,
                destroy: totalSlides <= 3,
                arrowPath: 'M2.68456 22.7027L30.604 22.7027L17.9866 35.4054C16.9128 36.4865 16.9128 38.1081 17.9866 39.1892C19.0604 40.2703 20.6711 40.2703 21.745 39.1892L39.1946 21.8919C39.1946 21.6216 39.4631 21.3514 39.7315 21.0811C39.7315 20.8108 40 20.5405 40 20C40 19.7297 40 19.1892 39.7315 18.9189C39.4631 18.6487 39.1946 18.3784 39.1946 18.1081L21.745 0.810811C20.6711 -0.27027 19.0604 -0.27027 17.9866 0.810811C16.9128 1.89189 16.9128 3.51351 17.9866 4.59459L30.604 17.2973L2.68456 17.2973C1.07382 17.2973 1.41767e-07 18.3784 0 20C-1.41766e-07 21.6216 1.34228 22.7027 2.68456 22.7027Z',
                classes: {
                    pagination: 'splide__pagination flex justify-center items-center gap-2 w-max !mx-auto pb-2',
                    page: 'splide__pagination__page rounded-full overflow-hidden w-3 h-3 opacity-50 hover:scale-105 [&.is-active]:opacity-100 transition-all duration-150 ease-in-out border border-black' + ' ' + paginationColor,
                    arrows: 'splide__arrows absolute bottom-0 right-0 w-full md:w-56 h-12 flex items-center justify-between px-6 lg:px-8 pb-4',
                    arrow: 'splide__arrow relative z-5 rounded-full w-12 h-12 p-4 bg-green-neon-re fill-current text-black disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 active:!duration-75 active:!scale-125 disabled:!scale-100 disabled:!opacity-20',
                    prev: 'splide__arrow--prev rotate-180',
                    next: 'splide__arrow--next',
                },
                breakpoints: {
                    1023: {
                        perPage: 2,
                        padding: '1.5rem',
                        gap: '1.5rem',
                        destroy: totalSlides <= 2,
                    },
                    767: {
                        perPage: 1,
                        padding: '1.5rem',
                        gap: '1.5rem',
                        destroy: totalSlides === 1,
                    },
                },
            });

            cardSplide.mount();
        }
        // END TESTIMONIAL PANEL SLIDER

    }
});
